import React from 'react';
import ReactDOMClient from 'react-dom/client';
import singleSpaReact from 'single-spa-react';
import { logger } from '@ecosystem/newron-client-lib';
import { feedbackV2 } from '@ecosystem/newron-design-system';
import { Root } from './root/Root';

const lifecycles = singleSpaReact({
  renderType: 'createRoot',
  React,
  ReactDOMClient,
  rootComponent: Root,
  errorBoundary(err: Error, info: React.ErrorInfo) {
    logger.error(err, {
      componentStack: info.componentStack,
    });
    return (
      <div id="newron-content">
        <div className="mx-16 my-16">
          <feedbackV2.Alert
            title={
              <>
                The requested data for this page has failed to load.
                <br /> Please refresh your browser to try again. If this issue persists, please contact your GfK
                representative.
              </>
            }
            type="error"
          />
        </div>
      </div>
    );
  },
});

export const { bootstrap, mount, unmount } = lifecycles;
